export const INTERVAL = 5000;
